import React, { useState } from "react";
// import LineColumnArea from './LineColumnArea';
import { useNavigate } from "react-router-dom"; // Import useNavigate
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import StudListTable from "../Tables/Maintable";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

const columnOptions = {
  chart: {
    type: "column",
  },
  title: {
    text: null,
  },
  xAxis: {
    categories: ["John Doe", "Jane Smith", "Emily Johnson"],
  },
  yAxis: {
    min: 0,
    title: {
      text: "Count",
    },
  },
  series: [
    {
      name: "Total Calls ",
      data: [25, 65, 65],

      color: "#7BA4F4",
    },
    {
      name: "Total Messages",
      data: [55, 52, 52],

      color: "#F2A867",
    },
    {
      name: "Total Mails",
      data: [63, 73, 73],

      color: "#F56F70",
    },
  ],
  credits: {
    enabled: false,
  },
  exporting: {
    enable: true,
    chartOptions: {
      title: {
        text: 'Unit Student  Details',
      },
    },
  },

};

const OverView = () => {
  const navigate = useNavigate();

  const columns = [
    { field: "sno", headerName: "S.no", width: 100 },
    { field: "studname", headerName: "Student Name", width: 300 },
    { field: "totunit", headerName: "Total Unit", width: 280 },
    { field: "status", headerName: "Active Status", width: 250 },
    { field: "tcalls", headerName: "Total Calls", width: 250 },
    { field: "tsms", headerName: "Total Messages", width: 250 },
    { field: "tmails", headerName: "Total Mails", width: 250 },

    { field: "dateltengaged", headerName: "Last Engaged", width: 280 },
  ];

  const rows = [
    {
      id: 1,
      sno: "1",
      studname: "John Doe",
      totunit: 55,
      tcalls: 25,
      status: "active",
      tsms: 55,
      tmails: 63,
      joindate: "12/01/2024",
      dateltengaged: "11-Sep-2024",
    },
    {
      id: 2,
      sno: "2",
      studname: "Jane Smith",
      totunit: 12,
      tcalls: 65,
      status: "active",
      tsms: 52,
      tmails: 73,
      joindate: "12-Jan-2024",
      dateltengaged: "12-Sep-2024",
    },
    {
      id: 3,
      sno: "3",
      studname: "Emily Johnson",
      totunit: 12,
      tcalls: 65,
      status: "active",
      tsms: 52,
      tmails: 73,
      joindate: "12/01/2024",
      dateltengaged: "23-Sep-2024",
    },
    // Add more rows as needed...
  ];

  const handleRowClick = (rowData) => {
    // Navigate to the desired page without passing in the URL
    navigate("/transcription", { state: { studentID: rowData.id } });
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className="d-flex gap-2 align-items-center mb-2 ms-1">
            <Button onClick={() => navigate(-1)} className="mb-0 back-arrow-btn">
              <i className="fas fa-arrow-left"></i>
            </Button>{" "}
            <h3 className="bold">Unit Student List</h3>
          </div>
          <Row className="g-2">
            <Col md={12}>
              <Card className="mb-2">
                <CardBody>
                  <div>
                    <div className="mt-3">
                      <StudListTable
                        columns={columns}
                        rows={rows}
                        onRowClick={handleRowClick}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="g-2">
            {/* Basic Column Chart */}
            <Col lg={6} className="mb-2">
              <Card className="mb-2 h-100 border">
                <CardBody>
                  <h5 className="f-16 bold mb-3">Unit Student  Details</h5>
                  <HighchartsReact highcharts={Highcharts} options={columnOptions} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OverView;
